export default{
    origenes: [],
    origenSelec: null,
}